import { X, Download, Store } from 'lucide-react';
import StatusBadge from '../../common/StatusBadge';

export default function ModalHeader({ store, validationResults, onClose, onExport }) {
    return (
        <div className="flex items-center justify-between p-8 bg-gradient-to-r from-slate-50 to-slate-100/80 border-b border-slate-200/60 flex-shrink-0">
            <div className="flex items-center gap-6">
                <div className="p-4 bg-white rounded-2xl shadow-sm border border-slate-200/60">
                    <Store size={28} className="text-slate-700" />
                </div>
                <div>
                    <h2 className="text-3xl font-bold text-slate-900 mb-1">Store Details</h2>
                    <p className="text-slate-600 text-lg font-medium">{store.name}</p>
                </div>
            </div>
            <div className="flex items-center gap-4">
                {validationResults && (
                    <StatusBadge score={validationResults.overallScore} />
                )}
                <button
                    onClick={onExport}
                    className="flex items-center gap-2 px-5 py-3 text-sm font-medium bg-white border border-slate-300 rounded-2xl hover:bg-slate-50 transition-all duration-200 shadow-sm"
                >
                    <Download size={18} />
                    Export Data
                </button>
                <button
                    onClick={onClose}
                    className="p-3 hover:bg-slate-200/80 rounded-2xl transition-colors duration-200 bg-white border border-slate-200"
                >
                    <X size={22} />
                </button>
            </div>
        </div>
    );
}
